import { SCORE_TIERS, SIZE_CLASS } from './ScoreBadge.constants';
import type { ScoreBadgeProps } from './ScoreBadge.types';

const tierClassFor = (score: number): string => {
	if (score >= SCORE_TIERS.good.min) return SCORE_TIERS.good.class;
	if (score >= SCORE_TIERS.warn.min) return SCORE_TIERS.warn.class;
	return SCORE_TIERS.bad.class;
};

export const ScoreBadge = ({ score, size = 'md', className = '' }: ScoreBadgeProps) => {
	if (score === null || score === undefined) {
		return (
			<span className={`inline-flex items-center rounded-full bg-grey-25 text-subtle ${SIZE_CLASS[size]} ${className}`}>
				—
			</span>
		);
	}
	const pct = Math.round(score * 100);
	const tierClass = tierClassFor(score);

	return (
		<span
			className={`inline-flex items-center rounded-full font-medium tabular-nums ${tierClass} ${SIZE_CLASS[size]} ${className}`}
		>
			{pct}%
		</span>
	);
};
